import * as React from 'react';
import { cn } from '@/lib/utils';

// 简单的 native <select>，B 设计语言下不需要复杂的下拉
export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
	({ className, children, ...props }, ref) => (
		<select
			ref={ref}
			className={cn(
				'bg-white border border-line rounded-md px-2.5 pr-7 py-1.5 text-[16px] text-ink-2 cursor-pointer transition-colors appearance-none',
				'hover:border-line-strong focus:outline-none focus:border-ink-3',
				'bg-no-repeat bg-[right_8px_center]',
				className
			)}
			style={{
				backgroundImage:
					"url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='%238c8c89' d='M0 0l5 6 5-6z'/></svg>\")",
			}}
			{...props}
		>
			{children}
		</select>
	)
);
Select.displayName = 'Select';
